import { Component } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { RequestServices } from 'src/app/services/request.service';
import { StorageService } from 'src/app/services/storage.service';
import { Configuration } from 'src/app/Constants/configuration';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CocheSeguro } from 'src/app/modelos/cocheSeguro.model';
import { NotificacionComponent } from '../notificacion/notificacion.component';
import { Prospecto } from 'src/app/modelos/prospecto.model';
import { DatosCotizacion } from 'src/app/modelos/datos-cotizacion.model';
import { LogConsumo, LogConsumoFunciones } from 'src/app/utilities/logConsumo';
import { Router } from '@angular/router';
import { StyleCocheSeguro } from 'src/app/modelos/styleCocheseguro.model';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  public login: Login = new Login();
  public const: Configuration = new Configuration();
  public styleCocheSeguro:StyleCocheSeguro = new StyleCocheSeguro();
  public logConsumoData: LogConsumo = new LogConsumo;
  public logConsumoFun: LogConsumoFunciones = new LogConsumoFunciones(this.requestService, this.storageService, this.router);
  public prospecto: Prospecto = new Prospecto();
  public datosCotizacion: DatosCotizacion = {
    multicotiza: {
      f1: new Configuration().MULTINEGOCIO_ID,
      f2: 29,
      f3: '',
      f4: new Date().getFullYear(),
      f5: 1,
      f7: 0
    },
    datosAuto: {
      paquete: 0,
      logoMarca: '',
      descripcion: ''
    }
  };

  constructor(private router: Router, private dialogRef: MatDialogRef<LoginComponent>, private storageService: StorageService, private requestService: RequestServices, private snackBar: MatSnackBar, private modal: MatDialog) {
    if (this.storageService.ifExist("styleCocheSeguro")) {
      this.styleCocheSeguro = JSON.parse(this.storageService.getItem("styleCocheSeguro"));
    }
   }

  ngOnInit() {
  }

  onLogin() {
    try {
      let cocheSeguro: CocheSeguro = new CocheSeguro();
      if (this.storageService.ifExist("cocheSeguro")) {
        cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
      }
      if (this.login.usr !== '' && this.login.pass !== '') {
        this.login.a = cocheSeguro?.a;
        this.login.grupo = cocheSeguro.grupoID;
        this.requestService.postRequest({ apiName: "InterAutosLoginApi", dataJSON: this.login }).subscribe(result => {
          if (result.error) {
            console.error("error", result.error);
            this.snackBar.open("Ocurrio un error durante el proceso.", result.error, { duration: this.const.SNACK_BARTIME });
          } else {
            if (result.existe === 1) {
              let cocheSeguro: CocheSeguro = new CocheSeguro();
              if (this.storageService.ifExist("cocheSeguro")) {
                cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
              }
              cocheSeguro.tkn = result.token;
              cocheSeguro.m = result.m;
              cocheSeguro.clEnt = result.clEnt;
              cocheSeguro.clEntInt = result.cte;
              this.storageService.setItem("cocheSeguro", JSON.stringify(cocheSeguro), "m");
              this.dialogRef.close();
            } else {
              this.snackBar.open("El correo o password son incorrectos.", "", { duration: this.const.SNACK_BARTIME });
            }
          }
        });
      }
    } catch (error) {
      console.error("error", error);
      this.snackBar.open("Ocurrio un error durante el proceso.", error, { duration: this.const.SNACK_BARTIME });
    }
  }

  recuperarContrasena() {
    try {
      let cocheSeguro: CocheSeguro = new CocheSeguro();
      if (this.storageService.ifExist("cocheSeguro")) {
        cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
      }
      if (this.login.pass !== '') {
        this.login.a = cocheSeguro?.a;
        this.login.grupo = cocheSeguro.grupoID;
        this.requestService.postRequest({ apiName: "InterAutosRecuperarContrasenaAPI", dataJSON: this.login }).subscribe(result => {
          if (result.error) {
            console.error("error", result.error);
            this.snackBar.open("Ocurrio un error durante el proceso.", result.error, { duration: this.const.SNACK_BARTIME });
          } else {
            if (result.existe === 1) {
              if (result.tieneContrasena) {
                let notificacion = this.modal.open(NotificacionComponent, { disableClose: false });
                notificacion.componentInstance.message = "<b class='font-marcameTxt'>Listo, recibirás un correo con tu contraseña.</b>";
                notificacion.componentInstance.accion = "ACEPTAR";
                notificacion.componentInstance.default = true;
              } else {
                let notificacion = this.modal.open(NotificacionComponent, { disableClose: false });
                notificacion.componentInstance.message = "No encontramos una contraseña asiganada en nuestros registros, si piensas que sea un error";
                notificacion.componentInstance.accion = "ACEPTAR";
                notificacion.componentInstance.error = true;
                notificacion.componentInstance.llamar = true;
              }
            } else {
              let cocheSeguro: CocheSeguro = new CocheSeguro();
              if (this.storageService.ifExist("cocheSeguro")) {
                cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
              }
              cocheSeguro.prospecto = this.prospecto;
              this.storageService.setItem("cocheSeguro", JSON.stringify(cocheSeguro));

              cocheSeguro.dataVehiculo = this.datosCotizacion;
              this.storageService.setItem("cocheSeguro", JSON.stringify(cocheSeguro));

              this.logConsumoData.v1 = "94c3qaBTlOBbdUWPBkxEmg==";
              this.logConsumoData.v2 = "";
              this.logConsumoData.v3 = "";
              this.logConsumoData.v4 = "";
              this.logConsumoData.v5 = 0;
              this.logConsumoData.v6 = "";
              this.logConsumoData.v7 = "";
              this.logConsumoData.v8 = "";
              this.logConsumoData.v9 = (cocheSeguro?.origen)?cocheSeguro.origen:0;//Origen modificar
              let resultado = this.logConsumoFun.logConsumo(this.logConsumoData);

              let notificacion = this.modal.open(NotificacionComponent, { disableClose: false });
              notificacion.componentInstance.message = "No encontramos tu correo en nuestros registros, si piensas que sea un error";
              notificacion.componentInstance.accion = "ACEPTAR";
              notificacion.componentInstance.error = true;
              notificacion.componentInstance.llamar = true;
            }
          }
        });
      }
    } catch (error) {
      console.error("error", error);
      this.snackBar.open("Ocurrio un error durante el proceso.", error, { duration: this.const.SNACK_BARTIME });
    }
  }

  validaCorreo() {
    if (this.login.usr === undefined || this.login.usr === "" || !this.login.usr.match("[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9]){1,}")) {
      return true;
    } else {
      return false;
    }
  }
}

export class Login {
  public usr: string;
  public pass: string;
  public a: string;
  public grupo: number;
  constructor() { }
}